import { render, staticRenderFns } from "./voucher-sale-checkout.vue?vue&type=template&id=631b4f83&scoped=true&"
import script from "./voucher-sale-checkout.vue?vue&type=script&lang=js&"
export * from "./voucher-sale-checkout.vue?vue&type=script&lang=js&"
import style0 from "./voucher-sale-checkout.vue?vue&type=style&index=0&id=631b4f83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b4f83",
  null
  
)

export default component.exports